import React from 'react'
import { Notification } from '@progress/kendo-react-notification'
import { Slide } from '@progress/kendo-react-animation'

const NotificationPure = (props) => {
  return (
    <Slide direction={props.notification ? 'up' : 'down'} style={props.style}>
      {
        props.notification && <Notification type={props.type} closable={true} onClose={props.onClose}>
          <span>{ props.message }</span>
        </Notification>
      }
    </Slide>
  )
}

export { NotificationPure as default }
